module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0073.jpg?v=c32315a4";